import { DocumentUrl } from "./cartable.model";

export interface GetLoanCommentsResponse {
  canBeDeleted: boolean;
  isSender: boolean;
  messageText: string;
  createDate: Date;
  createDatePersian: string;
  referrerMessageKey: string;
  seenDate: string;
  seenDatePersian: string;
  parentLoanComment: ParentLoanComment | null;
  creatorPersonInfo: CreatorPersonInfo;
  key: string;
  receivers: Receivers[];
  files: DocumentUrl[];
}

export interface ParentLoanComment {
  key: string;
  messageText: string;
  referrerMessageKey: string;
  createDate: string;
  createDatePersian: string;
  creatorPersonInfo: CreatorPersonInfo;
  parentLoanComment: ParentLoanComment;
  files: DocumentUrl[];
}
interface CreatorPersonInfo {
  userName: string;
  userId: number;
  firstName: string;
  lastName: string;
  fullName: string;
  genderType: string;
}
export interface Receivers {
  userName: string;
  userId: number;
  firstName: string;
  lastName: string;
  fullName: string;
}

export interface GetLoanCommentsChangesRequest {
  referenceKey: string;
  fromChatKey?: string | null;
}

export interface GetLoanCommentsChangesResponse {
  loanComments: GetLoanCommentsResponse[];
  deletedMessageKeys: string[];
}

export interface GetUsersReponse {
  id: number;
  mobileNumber: string;
  firstName: string;
  lastName: string;
  username: string;
  isActive: boolean;
  notificationEnabled: string;
  genderType: string;
  isSystemUser: boolean;
}

export interface SendMessageRequest {
  messageText: string;
  mentionedUserIds: number[];
  referrerMessageKey: string;
  files: DocumentUrl[];
  referenceKey: string;
}

export interface DeleteMessageRequest {
  referenceKey: string;
  messageKey: string;
}

export class ChatSearchRequest {
  paginationInfo: PaginationInfo | undefined;
  filter: Filter | undefined;
}
export class PaginationInfo {
  pageNumber: number | undefined;
  pageSize?: number = 10;
  rowNumber: number | undefined;
}
export class Filter {
  loanRequestId: 0 | undefined;
  customerNationalCode: string | undefined;
  customerFullName: string | undefined;
  customerMobileNumber: string | undefined;
  referenceKey: string | undefined;
  orchestratorToken: string | undefined;
  requestDateFrom: Date | undefined | string;
  requestDateTo: Date | undefined | string;
  settlementStatusDateFrom: Date | undefined | string;
  settlementStatusDateTo: Date | undefined | string;
  supplierIds: number[] | undefined;
  loanRequestStatus: string[] | undefined;
  supplierSettlementStatus: string[] | undefined;
  loanTemplateIds: number[] | undefined;
  loanRequestSources: string[] | undefined;
  supplierUserIds: number[] | undefined;
  baseDate: Date | undefined;
}

export interface ChatSearchResponse {
  type: string;
  creatorFullName: string;
  receiverFullName: string;
  creationDatePersian: string;
  createDate: Date;
  messageText: string;
  customerNationalCode: string;
  loanTemplateTitle: string;
  loanAmount: number;
  referenceKey: string;
  loanRequestId: number;
}

export interface ChatGetNotificationsResponse {
  person: Person;
  totalCount: number;
  details: NotificationDetail[];
}

export interface Person {
  userName: string;
  userId: number;
  firstName: string;
  lastName: string;
  fullName: string;
  genderType: string;
  nationalCode: string;
}

export interface NotificationDetail {
  messageText: string;
  sendDateTime: string;
  sendDateTimePersian: string;
}

export interface DeleteChatAttachmentRequest {
  referenceKey: string;
  fileId: string;
}

export interface ConfirmHasTheUserSeenRequest {
  referenceKey: string;
}
